import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { PasswordRulesMessages as pwdHintMessages } from 'ecs-react-components/dist/index.es';
import { messages } from './ChangePassword.i18n';

import PasswordField from './PasswordField';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';

const fields = ['oldPwd', 'newPwd', 'confirmNewPwd'];

class ChangePassword extends Component {
  onSubmit = (values) => {
    const creds = {
      userId: this.props.userId,
      oldPwd: values.oldPwd,
      newPwd: values.newPwd,
      confirmNewPwd: values.confirmNewPwd,
    };
    this.props.sendUpdatePasswordRequest(creds);
  }

  createPasswordMessage({ minLength, capitalLetters, numbers, specialCharacters }) {
    const { formatMessage } = this.props.intl;
    const description = formatMessage(pwdHintMessages.rules.description);
    const minLengthText = formatMessage(pwdHintMessages.rules.minLength, { minLength });
    const capitalLettersText = formatMessage(pwdHintMessages.rules.capitalLetters, { capitalLetters });
    const numbersText = formatMessage(pwdHintMessages.rules.numbers, { numbers });
    const specialCharactersText = formatMessage(pwdHintMessages.rules.specialCharacters, { specialCharacters });
    let delimitedList = '';
    if (minLength > 0) {
      delimitedList += minLengthText;
    }
    if (capitalLetters > 0) {
      delimitedList += capitalLettersText;
    }
    if (numbers > 0) {
      delimitedList += numbersText;
    }
    if (specialCharacters > 0) {
      delimitedList += specialCharactersText;
    }
    const passwordRulesFormat = formatMessage(pwdHintMessages.rules.format, { description, delimitedList });
    return (
      <span className="understated small password-help">
        {passwordRulesFormat}
      </span>);
  }

  clearAlert = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const {
      oldPwd,
      newPwd,
      confirmNewPwd,
      minLength,
      capitalLetters,
      numbers,
      specialCharacters,
    } = fieldsMeta;

    return (
      <div>
        <PasswordField
          placeholder={formatMessage(messages.placeholder.oldpassword)}
          type="password"
          field={ oldPwd }
        />
        <PasswordField
          placeholder={formatMessage(messages.placeholder.password)}
          type="password"
          field={ newPwd }
        >
          {this.createPasswordMessage({ minLength, capitalLetters, numbers, specialCharacters })}
        </PasswordField>
        <PasswordField
          placeholder={formatMessage(messages.placeholder.confirmpassword)}
          type="password"
          field={ confirmNewPwd }
        />
      </div>
    );
  }

  render() {
    const { handleSubmit, minLength, capitalLetters, numbers, specialCharacters } = this.props;

    return (
      <div className="settings-section">
        <h4 className="mt-2"><FormattedMessage { ...messages.title } /></h4>
        <p><FormattedMessage {...messages.description} /></p>
        <div className="row">
          <form className="col-sm-4"
            onSubmit={ handleSubmit(this.onSubmit)}
            onChange={this.props.onFormChange}
          >
            <Fields names={fields}
              component={this.renderFields}
              minLength={minLength}
              capitalLetters={capitalLetters}
              numbers={numbers}
              specialCharacters={specialCharacters}
            />
            <button type="submit" className="btn btn-primary"
              data-qa-item="change_password" onClick={ this.clearAlert }
            >
              <FormattedMessage { ...messages.button } />
            </button>
          </form>
        </div>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  minLength: PropTypes.number,
  capitalLetters: PropTypes.number,
  numbers: PropTypes.number,
  specialCharacters: PropTypes.number,
  intl: PropTypes.object,
  userId: PropTypes.string,
  sendUpdatePasswordRequest: PropTypes.func.isRequired,
  onFormChange: PropTypes.func,
};

const mapStateToProps = (state) => ({
  minLength: state.signUp.password.minLength,
  capitalLetters: state.signUp.password.capitalLetters,
  numbers: state.signUp.password.numbers,
  specialCharacters: state.signUp.password.specialCharacters,
  intl: PropTypes.object,
  userId: state.profile.user.userId,
});


const formConfig = {
  form: 'changepasswordform',
};

export default reduxForm(formConfig)(connect(mapStateToProps)(injectIntl(ChangePassword)));